import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

import { GlobalService } from '../../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PropertySearchService {

  search(url?, crit?) {
    const api   = url || (<any>_GlobalNS).api.property.search;
    const heads = {};
    const headers = new HttpHeaders(heads);
    const params = crit;
    
    return this._http.get(`${api}`, {headers: headers, params: params});
  }

  constructor(private _http: HttpClient, private _global: GlobalService) { }
  exportToExcel(url?, crit?) {
    const api = url || (<any>_GlobalNS).api.property.buildExcel;
    const heads = {};
    const headers = new HttpHeaders(heads);
    const params = crit;
    return this._http.get(`${api}`, { headers: headers, params: params });
  }
}
